// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3hqOi","itemsContainer":"style_itemsContainer__3N6zx"};